// FILE: src/components/ErrorBoundary.jsx
// Last-resort screen if a page crashes: plain words, a way home, and no
// technical detail on screen (the error goes to the console only).
import React from "react";
import { Box, Button, Card, CardContent, Typography } from "@mui/material";

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error, info) {
    console.error("Global Error Boundary Caught:", error, info);
  }

  render() {
    if (this.state.hasError) {
      return (
        <Box component="main" sx={{ minHeight: "100vh", display: "grid", placeItems: "center", p: 2, bgcolor: "background.default" }}>
          <Card sx={{ maxWidth: 480, borderRadius: 4 }}>
            <CardContent sx={{ p: 4 }}>
              <Typography variant="h1" sx={{ mb: 1 }}>
                Something went wrong
              </Typography>
              <Typography sx={{ color: "text.secondary", mb: 3 }}>
                This page stopped working. Your progress is saved. Reload the page, and if it happens again, contact
                student support.
              </Typography>
              <Button variant="contained" size="large" onClick={() => window.location.assign("/")}>
                Reload Zun Drivers
              </Button>
            </CardContent>
          </Card>
        </Box>
      );
    }
    return this.props.children;
  }
}

export default ErrorBoundary;
